import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { objToGETString, toFormData } from 'helpers';
import { attachAxiosCertWarning } from 'utils/certWarning';

const request = axios.create({
	validateStatus: (status) => {
		if (status === 401) {
			window.location.href = '/mw/auth/not_auth';
		}

		return status < 500;
	},
});

attachAxiosCertWarning(request);

const createRequestParams = (path, data, method, options) => {
	if (!path) {
		return false;
	}

	const normalizedMethod = (method || '').toLowerCase();
	const newParams = {
		url: path,
	};

	if (!data) {
		return newParams;
	}

	// Set headers.
	newParams.headers = options.jsonType
		? { 'content-type': 'application/json; charset=UTF-8' }
		: { 'content-type': 'application/x-www-form-urlencoded; charset=UTF-8' };

	if (options.contentType) {
		newParams.headers['content-type'] = options.contentType;
	}

	// Set request data.
	if (!options.jsonType) {
		if (data.file && !options.formData) {
			const rawFile = data.file?.file || data.file;

			newParams.params = data.data;
			newParams.data = data.file;
			newParams.headers['content-type'] = options.contentType
				|| rawFile?.type
				|| data.fileType
				|| data.data?.fileType
				|| 'application/octet-stream';
		} else {
			if (normalizedMethod === 'get') {
				newParams.params = data;
			} else if (options.formData) {
				newParams.data = toFormData(data);
			} else {
				newParams.data = objToGETString(data);
			}
		}
	} else {
		if (normalizedMethod === 'get') {
			newParams.params = data;
		} else {
			newParams.data = data;
		}
	}

	if (data.waitFile) {
		newParams.responseType = 'blob';
	}

	return newParams;
};

const baseQuery = ({ url, body, method, ...options }) => {
	return request({
		method,
		...createRequestParams(url, body, method, options),
	})
		.then((response) => {
			if (response.data && response.data.errorMessage && ['not_logged', 'no_session_id']
				.includes(response.data.errorMessage)) {
				sessionStorage.clear();
				window.location.href = `/mw/auth/not_auth?next=${encodeURI(window.location.href)}`;
				return true;
			}

			return response;
		})
		.catch((error) => {
			return Promise.reject({
				...error,
				message: error.response?.data?.errorMessage || error.response?.data?.error || error.message,
			});
		});
};

export default (options) => {
	return createApi({
		baseQuery,
		keepUnusedDataFor: 0,
		transformResponse: () => ({}),
		...options,
	});
};
